export default __webpack_public_path__ + "static/media/948.c9e2ded9.png";